/* @flow */
// typecheck: ignore file
import React from 'react';
import CurrentUser from 'auth/CurrentUser';
import Link from 'components/Link.jsx';
import type { Status } from 'reducers/zopim';
import { connect } from 'react-redux';
import Zopim from 'lib/Zopim';

type Props = {
  zopimStatus: Status,
  children?: React$Element<*>,
};

class ZopimLink extends React.Component {
  props: Props;

  showZopim = (event: SyntheticEvent) => {
    event.preventDefault();
    event.stopPropagation();
    Zopim.show();
  };

  render() {
    // We can't let underage children use live chat.
    const underaged = CurrentUser.isSignedIn() && CurrentUser.getUser().isUnderage();

    if (this.props.zopimStatus !== 'online' || underaged) {
      return null;
    }

    return (
      <Link onClick={this.showZopim}>
        {this.props.children}
      </Link>
    );
  }
}

function mapStateToProps(state: Object) {
  return {
    zopimStatus: state.zopim.status,
  };
}

export { ZopimLink };
export default connect(mapStateToProps, undefined)(ZopimLink);



// WEBPACK FOOTER //
// ./src/support/components/ZopimLink.jsx